import id from './id';

const createType = type => `${id}/${type}`;

export const SET_PAYMENT_DISTRIBUTION = createType('SET_PAYMENT_DISTRIBUTION');
export const LOCK_PAYMENT_DISTRIBUTION = createType('LOCK_PAYMENT_DISTRIBUTION');
export const SET_PAYMENT_METHOD = createType('SET_PAYMENT_METHOD');
